import { useQuery, type UseQueryResult } from '@tanstack/react-query';

import { NOTICE_QUERY_KEYS } from './keys';

import * as noticeService from 'services/notices';

import type { ServiceId, ServiceParams } from 'interface/service';
import type { Notice } from 'interface/notices';

type NoticeListResponse = { data?: Notice[]; meta?: { page?: number; total?: number } };

export const getNoticesQueryKey = (params: ServiceParams = {}) => [NOTICE_QUERY_KEYS.LIST, params] as const;

export const noticesQueryOptions = (params: ServiceParams = {}) => ({
  queryKey: getNoticesQueryKey(params),
  queryFn: () => noticeService.fetchAll(params) as Promise<NoticeListResponse>,
});

export const useFetchNoticesQuery = (
  params: ServiceParams = {},
  enabled = true
): UseQueryResult<NoticeListResponse, Error> => {
  return useQuery({
    ...noticesQueryOptions(params),
    enabled,
  });
};

export const getNoticeBoardQueryKey = (params: ServiceParams = {}) => [NOTICE_QUERY_KEYS.BOARD, params] as const;

export const noticeBoardQueryOptions = (params: ServiceParams = {}) => ({
  queryKey: getNoticeBoardQueryKey(params),
  queryFn: () => noticeService.fetchNoticeBoard(params) as Promise<NoticeListResponse>,
});

export const useFetchNoticeBoardQuery = (
  params: ServiceParams = {},
  enabled = true
): UseQueryResult<NoticeListResponse, Error> => {
  return useQuery({
    ...noticeBoardQueryOptions(params),
    enabled,
  });
};

export const getNoticeByIdQueryKey = (id?: ServiceId) => [NOTICE_QUERY_KEYS.DETAIL, id] as const;

export const useFetchNoticeByIdQuery = <TData = Notice>(
  id?: ServiceId,
  enabled = true
): UseQueryResult<TData, Error> => {
  return useQuery({
    queryKey: getNoticeByIdQueryKey(id),
    queryFn: () => noticeService.fetchById(id!) as Promise<TData>,
    enabled: Boolean(id) && enabled,
  });
};
